import { render, staticRenderFns } from "./UserSearchModal.vue?vue&type=template&id=b5a543ac&"
import script from "./UserSearchModal.vue?vue&type=script&lang=ts&"
export * from "./UserSearchModal.vue?vue&type=script&lang=ts&"
import style0 from "./UserSearchModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports